import React, { useEffect } from 'react';
import 'swiper/swiper-bundle.css';

function Homebody() {



  return (
    <div>
      <div className="slider-section">
        <div className="main-slider">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="slider-img-wrap">
                <div className="slider-img"><img src="assets/img/slider-bg.jpg" alt="img" /></div>
                <div className="corner-shape" data-animation="fade-in-left" data-duration="1.5s" data-delay="0.3s" />
              </div>
              <div className="slider-content-wrap d-flex align-items-center text-left">
                <div className="container">
                  <div className="slider-content">
                    <div className="slider-caption medium">
                      <div className="inner-layer">

                      </div>
                    </div>
                    <div className="slider-caption big">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.5s" style={{ color: window.innerWidth <= 768 ? 'white' : 'inherit' }}>Welcome To <br /><span>TITA Technologies</span>
                        </div>
                      </div>
                    </div>
                    <div className="slider-caption small">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.7s" data-duration="1s">One of the fastest-growing IT Sloutions 
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="slider-img-wrap">
                <div className="slider-img"><img src="assets/img/slider-bg.jpg" alt="img" /></div>
                <div className="corner-shape" data-animation="fade-in-left" data-duration="1.5s" data-delay="0.3s" />
              </div>
              <div className="slider-content-wrap d-flex align-items-center text-left">
                <div className="container">
                  <div className="slider-content">
                    <div className="slider-caption medium">
                      <div className="inner-layer">

                      </div>
                    </div>
                    <div className="slider-caption big">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.5s" style={{ color: window.innerWidth <= 768 ? 'white' : 'inherit' }}>Think IT,<br /> <span>Think TITA</span>
                        </div>
                      </div>
                    </div>
                    <div className="slider-caption small">
                      <div className="inner-layer">
                        <div data-animation="fade-in-bottom" data-delay="0.7s" data-duration="1s">Innovative IT Learning and
                          Development</div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>


          </div>
          <div className="slider-pagination" />{/* Carousel Dots */}
        </div>
      </div>

    </div>
  );
}

export default Homebody;
